"use client";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { LedgerWalletAdapter } from "@solana/wallet-adapter-ledger";
import { SolflareWalletAdapter } from "@solana/wallet-adapter-solflare";
import type { PropsWithChildren } from "react";
import { useMemo } from "react";

import { getRpcUrl } from "@/lib/config";

const WALLET_STORAGE_KEY = "phoenix-flight-wallet-name";

export const createWalletAdapters = () => [
  new SolflareWalletAdapter(),
  new LedgerWalletAdapter(),
];

export const SolanaWalletProvider = ({ children }: PropsWithChildren) => {
  const endpoint = getRpcUrl();
  const wallets = useMemo(createWalletAdapters, []);

  if (!endpoint) {
    throw new Error("NEXT_PUBLIC_RPC_URL is required to connect a wallet");
  }

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider
        wallets={wallets}
        autoConnect
        localStorageKey={WALLET_STORAGE_KEY}
      >
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
};
